import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import ListComponent from "@/components/listComponent"
import { MyContext } from "@/store/myContext"
import Detail from "./detail"
import { Modal , Image} from "antd"
import { getAppBannerList, appBannerDelete } from  "@/service/dataService"
import TopSearch from "@/components/TopSearch"
import {fileLookUrl } from "@/config/app.js"

//访问列表
export default () => {
    
const { t } = useTranslation();
const { state, message } = useContext(MyContext)
    const [showVisible, setShowVisible] = useState(false)
    const [showMode, setShowMode] = useState("")
    const [list, setList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息
    const linkType = {
        internal_link: t(`dataManage.appBannerSet.index.内部链接`),
        external_link: t(`dataManage.appBannerSet.index.外部链接`),
    }

    useEffect(() => {
        if (state.activeMenu === "appBannerSet") {
            loadData(pagination.current)
        }
    }, [state.activeMenu])// eslint-disable-line react-hooks/exhaustive-deps


    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { disableFlag: 0, ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
        }
        getAppBannerList(data).then((res) => {
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setList(res.retData.list)
        })
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //列表button
    const topButtons = [
        {
            click: () => handleDetails("insert"),
            content: t(`dataManage.appBannerSet.index.新增`),
        },
        {
            click: () => handleDetails("edit"),
            content: t(`dataManage.appBannerSet.index.编辑`),
        },
        {
            click: () => handleDelete(),
            content: t(`dataManage.appBannerSet.index.删除`),
        },
    ]

    //删除
    const handleDelete = async () => {
        if (!Object.keys(selectInfo.rowInfo).length) {
            message.warning(`${t(`dataManage.appBannerSet.index.请选择你要删除的`)}banner`);
            return
        }
        Modal.confirm({
            content: `${t(`dataManage.appBannerSet.index.确定要删除`)}?`,
            okText: t(`dataManage.appBannerSet.index.确定`),
            cancelText: t(`dataManage.appBannerSet.index.取消`),
            centered: true,
            onOk() {
                appBannerDelete(selectInfo.rowInfo.id).then((res) => {
                    message.success(t(`dataManage.appBannerSet.index.删除成功`))
                    loadData(pagination.current, searchValue)
                })
            },
        })
    }
    //新增
    const handleDetails = async (mode) => {
        if (mode === "edit") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.appBannerSet.index.请选择你要编辑的成员`))
                return
            }
        } else if (mode === "look") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`dataManage.appBannerSet.index.请选择你要查看的成员`))
                return
            }
        }
        setShowMode(mode)
        setShowVisible(true)
    }

    //table配置
    const columns = [
        {
            title: t(`dataManage.appBannerSet.index.图`),
            align: "center",
            dataIndex: "img",
            render: (text) => (text ? <Image src={`${fileLookUrl().image}${text}`} width={68} height={34} key={text} /> : ""),
        },
        {
            title: t(`dataManage.appBannerSet.index.跳转链接类型`),
            align: "center",
            dataIndex: "linkType",
            render: (text) => (linkType[text]),
        },
        {
            title: t(`dataManage.appBannerSet.index.跳转链接`),
            align: "center",
            dataIndex: "link",
        },
        
      
    ]
    // 搜索JSON
    const searchList = {
        normalList: [
            {
                type: "Checkbox",
                valueName: "disableFlag",
                placeholder: t(`dataManage.appBannerSet.index.禁用状态`),
                defaultChecked: searchValue.disableFlag ? true : false,
            },
        ],
    }

    return (
        <>
            {state.activeMenu === "appBannerSet" && (
                <>
                    <TopSearch
                        title= {t(`dataManage.appBannerSet.index.成员管理`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`dataManage.appBannerSet.index.成员管理`)}
                        buttons={topButtons}
                        selectInfo={selectInfo}
                        columns={columns}
                        dataSource={list}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                        scroll={{ x: 'max-content' }}
                    />

                    {showVisible && (
                        <Detail
                            rowInfo={selectInfo.rowInfo}
                            visible={showVisible}
                            mode={showMode}
                            setVisible={setShowVisible}
                            linkType={linkType}
                            onSuccess={() => {
                                loadData(1, searchValue)
                            }}
                        />
                    )}

                    
                </>
            )}
        </>
    )
}
